import React from 'react'
import { useForgotPassword } from './useForgotPassword'
import { FormikProvider } from 'formik';
import InputWrapper from '../../../modules/molecules/InputWrapper';
import { ReactComponent as UserIcon } from "../../../assets/svg/loginemail.svg";
import { Button } from 'gf-ui-components-mui-lib';
import AuthLayout from '../Login/components/AuthLayout';
import styles from "./styles.module.scss";
import { CircularProgress } from '@mui/material';

const ForgotPassword = () => {
    const { forgotFormik, handleSendLink, isLoading } = useForgotPassword();
    return (
        <FormikProvider value={forgotFormik}>
            <AuthLayout>
                <div>
                    <span className={`${styles['subtitle']}`} data-testid="forgot-subtitle" >Forgot Password</span>
                </div>
                <InputWrapper
                    {...{
                        label: 'Email',
                        name: 'email',
                        placeholder: 'Enter email',
                        startIcon: <UserIcon />
                    }}
                />
                <div className={`${styles['bottomContainer']}`}>
                    <Button
                        disabled={!(forgotFormik?.isValid && forgotFormik?.dirty)}
                        className={`${styles.sendLinkBtn} ${isLoading ? styles.loadingBtn : ''}`}
                        onClick={handleSendLink}
                        id="send-link-btn"
                    >
                        Send Link
                        {isLoading && <CircularProgress 
                            sx={{
                                width: '20px !important',
                                height: '20px !important',
                                color: '#fff'
                            }}
                        />}
                    </Button>
                </div>
            </AuthLayout>
        </FormikProvider>
    )
}

export default ForgotPassword